module.exports = __webpack_public_path__ + "f767d56a1ced5ba46650d1359c856edc.svg";